import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Form.css'
import axios from 'axios'
import { Container, Input, Form, FormGroup, Label, Button,Row,Col } from "reactstrap";
import { getQR } from './GenerateQR';
function Formm() {
    const [name,setName] = useState(null);
    const [mobile,setMobile] = useState(null);
    const [loading,setLoading] = useState(false);
    const [uri,setUri] =useState(null);
    const [error,setError] = useState('');
 
    const handleRequestAccess = async () => {
        if(name==null && mobile == null){
           setError('Please fill credentials correctly.')
        }
        else{
        setLoading(true);
        await axios
          .post(`https://bpcz64ctru.us-east-1.awsapprunner.com/api/commfor/user/odk/create-gd-inventory-mapping-odk-user`, {
            name: name,
            mobile: mobile
          })
          .then(function (response) {
            setLoading(false);
            setUri(getQR(response.data.token))
          })
          .catch(function (error) {
            setLoading(false);
            setLoading(false);
            console.log(error);
          });
        }
      };

  return (
    <Container>
        <Row style={{justifyContent:'center',alignItems:'center'}}>
            <Col md="6" sm="12" xs="12">
                <center>
                <h4 style={{marginTop:40}}>Gadchiroli Forest Resource Mapping</h4>

                </center>
            <Form style={{border:'1px solid',padding:40,borderRadius:10,marginTop:20}}>
    <FormGroup>
                <Input placeholder='Your Mobile Number' onChange={(e)=>setMobile(e.target.value)}  style={{ marginTop: 20 }}  className="inputBox1"/>
                <Input placeholder='Your Name'  onChange={(e)=>setName(e.target.value)}     style={{ marginTop: 20 }} className="inputBox1"/>
               <center>

                <Button size='sm' disabled={uri?true:false}  style={{ marginTop: 20,background:'#125912' }} onClick={handleRequestAccess}>{loading?'Generating...':'Generate QRCode'}</Button>
                {error!='' &&  error}
               </center>
                </FormGroup>
                </Form>
            </Col>
        </Row>
        {uri &&
        <Row style={{justifyContent:'center',alignItems:'center'}}>
        <Col md="6" sm="12" xs="12">
            <center>
              <br/>
            <p>Please scan it on ODK Collect/GIC Collect.</p>
             <img style={{ width: 200, height: 200 }} src={uri} alt="QR Code"/>
             <p style={{ marginTop: 10,display:'flex',justifyContent:'center' }}>
              <a href={uri} download="Boundary-Mapping-QRCode.jpg">
                <Button style={{ backgroundColor: "#124912",fontSize:14,border:'none'}} size="sm" className="submitButton">
                  Download QR
                </Button>
              </a>
            <a href="https://play.google.com/store/apps/details?id=org.odk.collect.android&hl=en&gl=US" target="_blank">
                <Button size="sm" style={{marginLeft:5,fontSize:14,background:'#aa8d27',border:'none'}} className="submitButton">
                  Get ODK Collect (Android)
                </Button>
              </a>
            <a href="https://apps.apple.com/us/app/gic-collect/id1485932698" target="_blank">
                <Button size="sm" style={{marginLeft:5,fontSize:14,background:'#0071e3',border:'none'}} className="submitButton">
                  Get GIC Collect (iOS)
                </Button>
              </a>

            </p>
            <p style={{ marginTop: 5,display:'flex',justifyContent:'center' }}>
              <a href="/ODK_Collect_Field_Guide.pdf" target="_blank" download="ODK_Collect_Field_Guide.pdf">
                <Button size="sm" style={{fontSize:14,background:'#6c757d',border:'none'}} className="submitButton">
                  Download ODK Collect Guide
                </Button>
              </a>
            <a href="/GIC_Collect_Field_Guide.pdf" target="_blank" download="GIC_Collect_Field_Guide.pdf">
                <Button size="sm" style={{marginLeft:5,fontSize:14,background:'#6c757d',border:'none'}} className="submitButton">
                  Download GIC Collect Guide
                </Button>
              </a>
            </p>
            </center>
            </Col>
        </Row>
}

    </Container>
  )
}

export default Formm